<div class="nav-wrapper">
    <nav myStickSubNav class="navbar navbar-default ">
        <div class="container-fluid">
            <div class="center-menu">
                <ul class="nav navbar-nav">
                    <li *ngFor="let link of subLinks">
                        <a *ngIf="link.alternateAction" (click)="takeAlternateAction(link.alternateAction)"
                            class="{{link.active ? 'active' : ''}}"
                            [style.display]="link.hidden ? 'none' : null"
                        >{{link.name}}</a>
                        <a *ngIf="!link.alternateAction" routerLink="{{link.routeLink}}"
                            routerLinkActive="active"
                            [style.display]="link.hidden ? 'none' : null"
                        >{{link.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</div>